import axios from "axios";
import videojs from "video.js";
import Cookies from 'js-cookie'
// video.js's stylesheet is injected from this bundle instead of being extracted
// into a pack stylesheet, so the page needs no third <link>. `sourceMap: false`
// is not cosmetic: this inline request carries no loader options, and css-loader
// 6 defaults `sourceMap` to whatever `devtool` says, so it would embed the whole
// stylesheet a second time (as sourcesContent) inside the JS every visitor
// downloads. css-loader 3, the version Webpacker 5 pinned, defaulted to false.
require('!style-loader!css-loader?{"sourceMap":false}!video.js/dist/video-js.css')
import videojsPlaylistPlugin from 'videojs-playlist';
videojs.registerPlugin('playlist', videojsPlaylistPlugin);

// Subtitle preference persisted across pills (and playlist transitions).
// Track labels come from the Mux track names we control (Mux::TrackCreator).
const subtitlePreferenceStorageKey = 'video_subtitle_preference'
const subtitleHintStorageKey = 'video_subtitle_hint_shown'
const reviewedTrackLabel = 'Español Revisado'
const generatedTrackLabel = 'Automáticos'

// Passed explicitly (NOT via data-setup): players initialized by video.js's
// autoSetup ended up on the native tech without VHS, which cannot play HLS
// on Chrome — quiz videos never loaded and subtitle tracks never appeared.
const playerOptions = { playbackRates: [0.5, 1, 1.5, 2] }

document.addEventListener("DOMContentLoaded", function (event) {
  if (document.querySelectorAll('#pill-player').length > 0) {
    const completePctNotification = 0.75;
    let notifyCompletionUrl = document.querySelector('#pill-player').dataset.notifyCompletionUrl;
    const modalText = document.querySelector('#pill-player').dataset.modalText;
    const modalLink = document.querySelector('#pill-player').dataset.modalLink;
    const saveLastPlayedSecond = document.querySelector('#pill-player').dataset.saveLastPlayedSecond === '1'
    // The playlist only comes populated for enrolled users: public visitors
    // get an empty list even with the flag on, and an empty playlist never
    // assigns a source (no VHS, no captions), so decide by actual content
    const playlistItems = getPlaylist();
    const usePlaylist = document.querySelector('#pill-player').dataset.usePlaylist === '1' && playlistItems.length > 0
    // Stand-in for playlist items when there is no playlist (public pills,
    // masterclass access). Its id MUST be the pill id (like playlist items):
    // it feeds the completion URL and the resume cookie. The completion URL
    // already carries it; data-container-id is the MuxVideo id, NOT valid here.
    const completionUrlMatch = (notifyCompletionUrl || '').match(/\/(\d+)\/complete/);
    const singleItem = {
      id: completionUrlMatch && completionUrlMatch[1],
      totalLength: document.querySelector('#pill-player').dataset.totalLength
    };

    let completionNotificationSent = false;
    let completionNotificationFailures = 0;
    const player = videojs('pill-player', playerOptions)

    if (usePlaylist) {
      player.playlist(playlistItems);
    } else {
      assignSourceExplicitly(player);
    }

    player.ready(function () {
      setupSubtitlePreferencePersistence(player);
      let currentItem = usePlaylist ? playlistItems[player.playlist.currentIndex()] : singleItem;

      if (saveLastPlayedSecond && Cookies.get(`video_${currentItem.id}`)) {
        player.currentTime(Cookies.get(`video_${currentItem.id}`))
      }

      player.on('timeupdate', function () {
        currentItem = usePlaylist ? playlistItems[player.playlist.currentIndex()] : singleItem;
        // saveLastPlayedSecond
        // We only save it every 5 seconds
        if (saveLastPlayedSecond && parseInt(this.currentTime()) % 5 == 0) {
          setCurrentTimeCookie(this.currentTime(), currentItem.id, currentItem.totalLength);
        }

        // notifyCompletion
        let notifyCompletionLength = parseFloat(currentItem.totalLength) * completePctNotification;

        if (!completionNotificationSent && this.currentTime() > notifyCompletionLength) {
          completionNotificationSent = true;
          notifyCompletionUrl = notifyCompletionUrl.replace(/\/(\d)+\/complete/, "/" + currentItem.id + "/complete")

          axios.get(notifyCompletionUrl, {
            headers: { 'Accept': 'application/json' }
          })
            .catch(function (error) {
              // Retry on transient failures, but give up after a few: for
              // visitors without completion rights this fails on EVERY
              // attempt and used to loop once per timeupdate
              completionNotificationFailures += 1;
              completionNotificationSent = completionNotificationFailures >= 3;
              console.log(error);
            })
        }
      })

      if (modalText && modalLink) {
        const modal = createModal(player, modalText, modalLink)

        player.addChild(modal);
        player.on('play', () => { modal.close() });
        player.on('ended', () => {
          modal.open()

          if (usePlaylist) {
            setModalLinkAttributes(player, modalLink);

            document.querySelector('.js-modal-link').addEventListener('click', function (event) {
              player.playlist.next();
              completionNotificationSent = false;
            });
          }
        });

      }
    });
  }

  document.querySelectorAll('video[id^="quiz-question-"]').forEach(function (videoElement) {
    if (videoElement.id.endsWith('_html5_api')) { return; } // already initialized tech element
    const quizPlayer = videojs(videoElement.id, playerOptions);
    assignSourceExplicitly(quizPlayer);
    quizPlayer.ready(function () {
      setupSubtitlePreferencePersistence(quizPlayer);
    });
  });
});

// HLS only engages VHS when the source is assigned through player.src():
// with the <source> child tag alone, this video.js version hands the m3u8 to
// the native tech, which cannot play it on Chrome (and never exposes the
// subtitle tracks). Playlist mode is fine because the plugin calls src().
function assignSourceExplicitly(player) {
  const sourceElement = player.el().querySelector('source');

  if (!sourceElement) { return; }

  player.src({ src: sourceElement.getAttribute('src'), type: sourceElement.getAttribute('type') });
}

function setupSubtitlePreferencePersistence(player) {
  const textTracks = player.textTracks();

  if (!textTracks) { return; }

  // Snapshot of the last state we applied programmatically, so the change
  // handler can tell our own changes apart from real user interactions.
  let lastProgrammaticState = null;

  // VHS also flips track modes on its own (it disables a subtitle track whose
  // playlist/segments fail to load, e.g. a network blip or an expired signed
  // URL). Those are not user choices either: only persist a change that
  // closely follows a real gesture on the player (the subtitles menu).
  let lastUserGestureAt = 0;
  const noteUserGesture = () => { lastUserGestureAt = Date.now(); };
  player.el().addEventListener('pointerdown', noteUserGesture, true);
  player.el().addEventListener('keydown', noteUserGesture, true);

  const userGestureRecent = () => (Date.now() - lastUserGestureAt) < 1000;

  const currentState = () => {
    const subtitleTracks = getSubtitleTracks(textTracks);
    const showingTrack = subtitleTracks.find((track) => track.mode === 'showing');

    return showingTrack ? { enabled: true, label: showingTrack.label || '' } : { enabled: false };
  }

  const statesMatch = (stateA, stateB) => {
    if (!stateA || !stateB) { return false; }
    if (stateA.enabled !== stateB.enabled) { return false; }

    return !stateA.enabled || normalizeTrackLabel(stateA.label) === normalizeTrackLabel(stateB.label);
  }

  const showOnlyTrack = (subtitleTracks, selectedTrack) => {
    subtitleTracks.forEach((track) => {
      track.mode = (track === selectedTrack) ? 'showing' : 'disabled';
    });
  }

  const applySubtitlePreference = () => {
    const subtitleTracks = getSubtitleTracks(textTracks);

    if (subtitleTracks.length === 0) { return; }

    const preference = getSubtitlePreference();

    // No stored preference: subtitles are entirely up to the user (we also
    // avoid overriding browser/system-level caption accessibility settings).
    // A one-time hint (maybeShowSubtitleHint) tells them about the menu.
    if (!preference) { return; }

    if (!preference.enabled) {
      showOnlyTrack(subtitleTracks, null);
      lastProgrammaticState = { enabled: false };
      return;
    }

    // Preferred track first, then fallbacks. Falling back NEVER overwrites
    // the stored preference (only real user interactions persist, below).
    const candidateLabels = [preference.label, reviewedTrackLabel, generatedTrackLabel];

    let selectedTrack = null;
    for (const label of candidateLabels) {
      selectedTrack = findTrackByLabel(subtitleTracks, label);
      if (selectedTrack) { break; }
    }
    selectedTrack = selectedTrack || subtitleTracks[0];

    showOnlyTrack(subtitleTracks, selectedTrack);
    lastProgrammaticState = { enabled: true, label: selectedTrack.label || '' };
  }

  const persistSubtitlePreference = () => {
    const subtitleTracks = getSubtitleTracks(textTracks);

    if (subtitleTracks.length === 0) { return; }

    const state = currentState();

    // Change events fired by applySubtitlePreference itself: not the user
    if (statesMatch(state, lastProgrammaticState)) { return; }

    // Third-party programmatic change (VHS disabling a broken track): keep
    // the snapshot so the preference re-applies on the next video untouched
    if (!userGestureRecent()) { return; }

    lastProgrammaticState = null;
    setSubtitlePreference(state);
  }

  // VHS (the HLS engine) sometimes misses a mode change fired before its
  // subtitle loader subscribes: the menu shows the track selected but no
  // cues ever load. Re-kick it with a disabled->showing toggle. The change
  // handlers read live state, so they only ever observe the final "showing"
  // (which matches the snapshot and is not persisted).
  const reassertShowingTrack = () => {
    const subtitleTracks = getSubtitleTracks(textTracks);
    const showingTrack = subtitleTracks.find((track) => track.mode === 'showing');

    if (!showingTrack) { return; }
    if (showingTrack.cues && showingTrack.cues.length > 0) { return; }

    showingTrack.mode = 'disabled';
    showingTrack.mode = 'showing';
  }

  player.on('loadedmetadata', applySubtitlePreference);
  player.on('playlistitem', applySubtitlePreference);
  player.on('playing', reassertShowingTrack);
  player.one('playing', function () { maybeShowSubtitleHint(player); });
  textTracks.addEventListener('addtrack', applySubtitlePreference);
  textTracks.addEventListener('change', persistSubtitlePreference);
}

// One-time notice: subtitles exist and the choice will be remembered.
// Only when the user has never expressed a preference.
function maybeShowSubtitleHint(player) {
  try {
    if (localStorage.getItem(subtitleHintStorageKey)) { return; }
  } catch (error) {
    return;
  }
  if (getSubtitlePreference()) { return; }
  if (getSubtitleTracks(player.textTracks()).length === 0) { return; }

  const hint = document.createElement('div');
  hint.textContent = 'Este vídeo tiene subtítulos: actívalos en el menú CC del reproductor. Recordaremos tu elección.';
  // #1BA14E = the app's green-dark (tailwind). Anchored left so it never
  // overlaps the subtitles menu, which opens over the right side controls.
  hint.style.cssText = 'position:absolute;left:1em;bottom:4.5em;max-width:65%;background:#1BA14E;' +
    'color:#fff;padding:1em 1.2em;border-radius:8px;font-size:1.3em;line-height:1.4;z-index:2;cursor:pointer;';
  player.el().appendChild(hint);

  const dismissHint = () => {
    hint.remove();
    try {
      localStorage.setItem(subtitleHintStorageKey, '1');
    } catch (error) {
      // Storage unavailable: the hint may show again, not a problem
    }
  };

  hint.addEventListener('click', dismissHint);
  setTimeout(dismissHint, 8000);
}

function getSubtitleTracks(textTracks) {
  const output = [];

  for (let index = 0; index < textTracks.length; index += 1) {
    const track = textTracks[index];
    if (track && (track.kind === 'subtitles' || track.kind === 'captions')) {
      output.push(track);
    }
  }

  return output;
}

function findTrackByLabel(subtitleTracks, label) {
  const normalizedLabel = normalizeTrackLabel(label);

  return subtitleTracks.find((track) => normalizeTrackLabel(track.label) === normalizedLabel);
}

function normalizeTrackLabel(label) {
  return (label || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[\s_-]+/g, '')
    .trim();
}

function getSubtitlePreference() {
  try {
    const rawValue = localStorage.getItem(subtitlePreferenceStorageKey);
    return rawValue ? JSON.parse(rawValue) : null;
  } catch (error) {
    return null;
  }
}

function setSubtitlePreference(preference) {
  try {
    localStorage.setItem(subtitlePreferenceStorageKey, JSON.stringify(preference));
  } catch (error) {
    // Storage unavailable (private mode / strict settings): fail silently
  }
}


function setCurrentTimeCookie(currentTime, containerId, totalLength) {
  const maxSecondSaved = totalLength * 0.95;

  if (currentTime < maxSecondSaved) {
    Cookies.set(`video_${containerId}`, parseInt(currentTime));
  } else if (Cookies.get(`video_${containerId}`)) {
    // If the stuent already passed 95% of the video, last second viewed is not worth saving.
    Cookies.remove(`video_${containerId}`);
  }
}

function createModal(player, modalText, modalLink) {
  const ModalDialog = videojs.getComponent('ModalDialog');
  const modal = new ModalDialog(player, {
    temporary: false,
    closeable: false
  });

  modal.on('modalopen', function () {
    modal.contentEl().innerHTML = `
      <div class='pill-video-modal'>
        <a href="${modalLink}" class="button js-modal-link">${modalText}</a>
      </div>
    `;
  });

  return modal;
}

function setModalLinkAttributes(player, modalLink) {
  const link = document.querySelector(".js-modal-link");
  const items = getPlaylist();
  const currentItem = items[player.playlist.currentIndex()];
  const nextItem = items[player.playlist.nextIndex()];

  if (currentItem != nextItem) {
    link.dataset.remote = true;
    link.setAttribute('href', nextItem.refreshUrl);
  } else {
    modalLink = modalLink.replace(/\/(\d)+\/complete/, "/" + currentItem.id + "/complete")
    link.dataset.remote = false;
    link.setAttribute('href', modalLink);
  }
}

function getPlaylist() {
  return JSON.parse(document.querySelector('#pill-player').dataset.playlist);
}
